import React, { useState, useMemo } from 'react';
import './SavedRecipesDrawer.css';

const SavedRecipesDrawer = ({ isOpen, onClose, savedRecipes, onDeleteRecipe }) => {
  const [expandedRecipeId, setExpandedRecipeId] = useState(null);

  const handleToggleExpand = (recipeId) => {
    setExpandedRecipeId(expandedRecipeId === recipeId ? null : recipeId);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const storeEntries = useMemo(() => {
    if (!savedRecipes || typeof savedRecipes !== 'object') {
      return [];
    }
    return Object.entries(savedRecipes);
  }, [savedRecipes]);

  const totalRecipes = useMemo(() => {
    return storeEntries.reduce((sum, [, recipes]) => sum + recipes.length, 0);
  }, [storeEntries]);

  return (
    <>
      <div 
        className={`drawer-overlay ${isOpen ? 'open' : ''}`}
        onClick={onClose}
      />
      <div className={`saved-recipes-drawer ${isOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <h2 className="drawer-title">Saved Recipes</h2>
          <button className="drawer-close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="drawer-content">
          {totalRecipes === 0 ? (
            <div className="empty-saved-recipes">
              <p>No saved recipes yet</p>
              <p className="empty-saved-recipes-subtitle">Save recipes from the Recipe List to view them here!</p>
            </div>
          ) : (
            <div className="saved-recipes-stores">
              {storeEntries.map(([storeName, recipes]) => (
                <div key={storeName} className="saved-recipes-store-section">
                  <div className="saved-recipes-store-header">
                    <h3 className="saved-recipes-store-title">{storeName}</h3>
                    <span className="saved-recipes-store-count">
                      {recipes.length} recipe{recipes.length !== 1 ? 's' : ''}
                    </span>
                  </div>

                  <div className="saved-recipes-list">
                    {recipes.map((recipe) => (
                      <div key={recipe.id} className="saved-recipe-card">
                        <div 
                          className="saved-recipe-header"
                          onClick={() => handleToggleExpand(recipe.id)}
                        >
                          <div className="saved-recipe-header-content">
                            <h4 className="saved-recipe-title">{recipe.title}</h4>
                            <div className="saved-recipe-meta">
                              <span className="saved-recipe-price">${recipe.price?.toFixed ? recipe.price.toFixed(2) : Number(recipe.price || 0).toFixed(2)}</span>
                              <span className="saved-recipe-date">{formatDate(recipe.dateSaved)}</span>
                            </div>
                          </div>
                          <div className="saved-recipe-actions">
                            <button
                              className="delete-recipe-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                onDeleteRecipe(recipe.id, storeName);
                              }}
                              title="Delete recipe"
                            >
                              🗑️
                            </button>
                            <span className="expand-icon">
                              {expandedRecipeId === recipe.id ? '▼' : '▶'}
                            </span>
                          </div>
                        </div>
                        
                        <div className={`saved-recipe-content ${expandedRecipeId === recipe.id ? 'expanded' : ''}`}>
                          {recipe.ingredients && recipe.ingredients.length > 0 && (
                            <div className="saved-recipe-section">
                              <h5 className="saved-recipe-section-title">Ingredients:</h5>
                              <ul className="saved-recipe-ingredients">
                                {recipe.ingredients.map((ingredient, index) => (
                                  <li key={index}>{ingredient}</li>
                                ))}
                              </ul>
                            </div>
                          )}

                          {recipe.instructions && (
                            <div className="saved-recipe-section">
                              <h5 className="saved-recipe-section-title">Instructions:</h5>
                              <p className="saved-recipe-instructions">{recipe.instructions}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SavedRecipesDrawer;

